module.exports = __webpack_public_path__ + "static/media/work.0e3e9ee7.webp";